import { Component, OnInit, Input } from '@angular/core';
import { GLOBAL } from 'src/app/services/GLOBAL';

@Component({
  selector: 'app-footer-one',
  templateUrl: './footer-one.component.html',
  styleUrls: ['./footer-one.component.scss']
})
export class FooterOneComponent implements OnInit {

  @Input() class: string = 'footer-light' // Default class 
  @Input() public themeLogo: string = GLOBAL.url + "/uploads/configuraciones/logo.png";

  @Input() newsletter: boolean = true; // Default True

  public today: number = Date.now();

  constructor() { }

  ngOnInit(): void {
  }

}
